import React from 'react'
import PropTypes from 'prop-types'
import { Dialog, DialogTitle, DialogContent, DialogActions, Divider, Slide } from '@material-ui/core'
import { CustomButton } from 'components/CustomButton'
import useStyles from './styles'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

export const ModalConfirmacao = (props) => {
  const {
    aberto,
    onClose,
    onConfirm,
    processando = false,
    disabled = false,
    titulo,
    confirmarLabel = 'Confirmar',
    cancelarLabel = 'Cancelar',
    confirmarColor = 'secondary',
    cancelarColor = 'primary',
    maxWidth = 'sm',
    fullWidth = true,
    children,
  } = props

  const classes = useStyles()

  return (
    <Dialog
      open={aberto}
      onClose={onClose}
      TransitionComponent={Transition}
      keepMounted
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      classes={{ paper: classes.paper }}
      aria-labelledby="modal-confirmacao-titulo"
    >
      {titulo && (
        <>
          <DialogTitle id="modal-confirmacao-titulo" disableTypography className={classes.header}>
            <b>{titulo.toUpperCase()}</b>
          </DialogTitle>
          <Divider />
        </>
      )}

      <DialogContent className={classes.content}>
        {children}
      </DialogContent>

      <Divider />

      <DialogActions className={classes.actions}>
        <CustomButton variant="outlined" colorType={cancelarColor} onClick={onClose}>
          {cancelarLabel}
        </CustomButton>
        <CustomButton variant="contained" colorType={confirmarColor} disabled={disabled || processando} isLoading={processando} onClick={onConfirm}>
          {confirmarLabel}
        </CustomButton>
      </DialogActions>
    </Dialog>
  )
}

ModalConfirmacao.propTypes = {
  aberto: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  processando: PropTypes.bool,
  disabled: PropTypes.bool,
  titulo: PropTypes.string,
  confirmarLabel: PropTypes.string,
  cancelarLabel: PropTypes.string,
  confirmarColor: PropTypes.oneOf(['primary', 'secondary', 'success', 'warning', 'error']),
  cancelarColor: PropTypes.oneOf(['primary', 'secondary', 'success', 'warning', 'error']),
  maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false]),
  fullWidth: PropTypes.bool,
  children: PropTypes.node,
}
